var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconDownComponent(props, ref) {
  var prefixFromContext = useContext(Context).prefix;
  var _a = props.className,
    className = _a === void 0 ? '' : _a,
    prefixFromProps = props.prefix,
    _b = props.width,
    width = _b === void 0 ? '1em' : _b,
    _c = props.height,
    height = _c === void 0 ? '1em' : _c,
    _d = props.useCurrentColor,
    useCurrentColor = _d === void 0 ? true : _d,
    rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor"]);
  var prefix = prefixFromProps || prefixFromContext || 'arco';
  return /*#__PURE__*/React.createElement("svg", __assign({
    className: "".concat(prefix, "-icon ").concat(prefix, "-icon-down ").concat(className),
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    fill: useCurrentColor ? 'currentColor' : '#000',
    xmlns: "http://www.w3.org/2000/svg"
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2206 5.43834C12.0905 5.30817 11.8794 5.30817 11.7492 5.43834L7.99997 9.18762L4.25071 5.43834C4.12053 5.30817 3.90948 5.30817 3.7793 5.43834L3.3079 5.90975C3.17772 6.03992 3.17772 6.25098 3.3079 6.38115L7.52856 10.6018C7.78891 10.8622 8.21102 10.8622 8.47137 10.6018L12.692 6.38115C12.8222 6.25098 12.8222 6.03992 12.692 5.90975L12.2206 5.43834Z",
    fillOpacity: "1"
  }));
}
var IconDown = /*#__PURE__*/React.forwardRef(IconDownComponent);
export default IconDown;